import { is } from "../../../utils/type-guards";

import type { ITrackingFormatter } from "./types";

export const createDefaultFormatter = <
    Key extends string = string,
    Value = unknown,
    Result = string,
>(): ITrackingFormatter<Key, Value, Result> => {
    return {
        keys: () => true,
        format(_filterKey, value): Result {
            if (is.undefined(value) || value === null) {
                return "" as Result;
            }

            if (is.string(value)) {
                return value as Result;
            }

            try {
                return JSON.stringify(value) as Result;
            } catch {
                return String(value) as Result;
            }
        },
    };
};
